import React, { useState } from 'react';
import styles from '../../styles/Search.module.css';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountDown, faBars, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { faCalendarMinus } from '@fortawesome/fontawesome-free-regular';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';

const ResultCountBar = ({ rcbArg, didSearchTxt }) => {
    const [curDateIndex, setCurDateIndex] = useState(0);
    const [dateSelected, setDateSelected] = useState();
    const [filterBtnTxt, setFilterBtnTxt] = useState();
    const filterIcon = <FontAwesomeIcon icon={faSortAmountDown} />;
    const categoryIcon = <FontAwesomeIcon icon={faBars} />;
    const dateIcon = <FontAwesomeIcon icon={faCalendarMinus} />;

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            關閉
        </Tooltip>
    );

    const currentYear = new Date().getFullYear();

    const chooseCategory = (cat) => {
        // Apply category and immediately trigger a new search with updated filter.
        rcbArg.setCategory(cat);
        rcbArg.setOpenCategory(!rcbArg.openCategory);
        rcbArg.onCategoryComplete(cat);
    };

    const chooseSorting = (sortingType) => {
        rcbArg.setSorting(sortingType);
        rcbArg.setOpenSorting(!rcbArg.openSorting);
        rcbArg.onSortingComplete(sortingType);
    };

    const removeCategory = () => {
        // reset the category to empty array
        rcbArg.setCategory([]);

        //call do search again
        rcbArg.onCategoryComplete([]);
    }

    const removeDateFilter = () => {
        // Reset to default year range and clear date-range filter on search.
        rcbArg.setDateFilter([currentYear, currentYear]);

        //close the date picker
        rcbArg.setOpenDateFilter(false);

        //call do search again
        rcbArg.onDateFilterComplete(null);

        //clear the selected date
        setDateSelected('');
    };

    const removeSortingFilter = () => {
        rcbArg.setSorting('def');
        //reset sorting filter to default
        rcbArg.onSortingComplete('def');
    };

    const categoryFilter = () => {
        if (rcbArg.category && rcbArg.category.length !== 0) {
            return (
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip}
                >
                    <div className={styles.categoryTag} onClick={() => { removeCategory() }}>{rcbArg.category.title}&#x2716;</div>
                </OverlayTrigger>
            );
        } else {
            return (
                <div className={styles.categoryLable} onClick={() => { rcbArg.setOpenCategory(!rcbArg.openCategory) }}>分類 {categoryIcon}</div>
            );
        }
    };

    const dateFilter = () => {
        if (rcbArg.dateFilter[0] !== currentYear && rcbArg.dateFilter[1] !== currentYear) {
            return (
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip}
                >
                    <div className={styles.categoryTag} onClick={() => { removeDateFilter() }}>{filterBtnTxt} &#x2716;</div>
                </OverlayTrigger>
            );
        } else {
            return (
                <div className={styles.categoryLable} onClick={() => { openUpDateFilter() }}>日期 {dateIcon}</div>
            )
        }
    };

    const openUpDateFilter = () => {
        // Reset temporary picker states before opening the modal.
        setDateSelected('');
        setFilterBtnTxt('');
        setCurDateIndex(0);

        //open up the date filter
        rcbArg.setOpenDateFilter(!rcbArg.openDateFilter)
    };

    const sorting = () => {
        if (rcbArg.sorting === 'def') {
            return (
                <div className={styles.filterLable} onClick={() => { rcbArg.setOpenSorting(!rcbArg.openSorting) }}>排序 {filterIcon}</div>
            );
        }
        else {
            let sortingTxt = rcbArg.sorting === 'n2o' ? "新至舊" : "舊至新";
            return (
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip}
                >
                    <div className={styles.categoryTag} onClick={() => { removeSortingFilter() }}>{sortingTxt} &#x2716;</div>
                </OverlayTrigger>
            );
        }
    };

    const categoryPopup = (data = []) => {
        if (data.length > 0) {
            let bodyItems = [];
            for (let i = 0; i < data.length; i++) {
                let itemData = data[i];
                bodyItems.push(
                    <div className={styles.catBtn} onClick={() => { chooseCategory(itemData) }} key={i}>{itemData.title}</div>
                );
            }
            
            return (
                <Modal
                    show={rcbArg.openCategory}
                    onHide={() => { rcbArg.setOpenCategory(!rcbArg.openCategory) }}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            選擇分類
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {bodyItems}
                    </Modal.Body>
                </Modal>
            );
        }
        
        return(<></>);

    };

    const sortingPopup = () => {
        return (
            <Modal
                show={rcbArg.openSorting}
                onHide={() => { rcbArg.setOpenSorting(!rcbArg.openSorting) }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        選擇分類
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <div className={styles.catBtn} onClick={() => { chooseSorting('def') }}>綜合</div> */}
                    <div className={styles.catBtn} onClick={() => { chooseSorting('n2o') }}>新至舊</div>
                    <div className={styles.catBtn} onClick={() => { chooseSorting('o2n') }}>舊至新</div>
                </Modal.Body>
            </Modal>
        );
    };

    const datePopup = () => {
        return (
            <Modal
                show={rcbArg.openDateFilter}
                onHide={() => { removeDateFilter() }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        選擇<span className={styles.highlight}>{curDateIndex === 0 ? "開始" : "完結"}</span>日期
                        <div className={styles.dateSelected}>{dateSelected}</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {datePicker()}
                </Modal.Body>
            </Modal>
        );
    };

    const datePicker = () => {
        let rows = [];
        let yy = new Date().getFullYear();
        let mm = 12;
        let startYear = 2004;

        // Year navigation is bounded to avoid invalid historical/future ranges.
        let showLastMonthBtn = (rcbArg.dateFilter[curDateIndex] - 1 >= startYear) ? true : false;
        let showNextMonthBtn = (rcbArg.dateFilter[curDateIndex] + 1 <= yy) ? true : false;
        let dateSelectedTxt = rcbArg.dateFilter[curDateIndex];

        //loop for month
        for (let i = 1; i <= mm; i++) {
            rows.push(
                <Col lg={3} xs={3} style={{ padding: 0 }} key={i}>
                    <div className={styles.monthBtn} onClick={() => { selectDate(i) }}> {i}月</div>
                </Col>
            );
        }

        const selectDate = (selectMonth) => {
            // First click sets start month, second click sets end month and triggers search.
            let dateData = [...rcbArg.dateFilter];
            dateData[curDateIndex] = rcbArg.dateFilter[curDateIndex] + '-' + selectMonth;
            rcbArg.setDateFilter(dateData);

            if (curDateIndex === 0) {
                setDateSelected(`開始日期：${rcbArg.dateFilter[0]} 年 ${selectMonth} 月`);
                setFilterBtnTxt(`${selectMonth}/${rcbArg.dateFilter[0]}`);
            }
            
            if (curDateIndex === 1) {
                
                // Convert selected start/end months to unix timestamps for Algolia filter syntax.
                let startDate = new Date((rcbArg.dateFilter[0] + '-01').replace(/-/g, "/"));
                let startDateUnix = Math.floor(startDate.getTime() / 1000);
                
                let endDate = new Date((rcbArg.dateFilter[1] + '-' + selectMonth + '-31').replace(/-/g, "/"));
                let endDateUnix = Math.floor(endDate.getTime() / 1000);
                
                // Algolia numeric range syntax: "<start> TO <end>".
                let dateRange = startDateUnix + ' TO ' + endDateUnix;
                
                // Complete date selection and execute search immediately.
                rcbArg.onDateFilterComplete(dateRange);
                //close the date picker
                rcbArg.setOpenDateFilter(!rcbArg.openDateFilter);
                //update btn txt
                setFilterBtnTxt(`${filterBtnTxt} - ${selectMonth}/${rcbArg.dateFilter[1]}`);

                setCurDateIndex(0);
                return;
            }

            //adjust current data index
            setCurDateIndex(curDateIndex + 1);
        }

        const lastMonth = () => {
            let dateData = [...rcbArg.dateFilter];
            dateData[curDateIndex]--;
            rcbArg.setDateFilter(dateData);
        }

        const nextMonth = () => {
            let dateData = [...rcbArg.dateFilter];
            dateData[curDateIndex]++;
            rcbArg.setDateFilter(dateData);
        }

        return (
            <div>
                <Container>
                    <Row>
                        <Col xs={3}>
                            {showLastMonthBtn && <div className={styles.arrowBtn} onClick={() => { lastMonth() }}>&#8592;</div>}
                        </Col>
                        <Col xs={6}><div className={styles.year}>{dateSelectedTxt}</div></Col>
                        <Col xs={3}>
                            {showNextMonthBtn && <div className={styles.arrowBtn} onClick={() => { nextMonth() }}>&#8594;</div>}
                        </Col>
                    </Row>
                </Container>
                <Container className={styles.pickerHolder}><Row>{rows}</Row></Container>
            </div>
        );
    };

    const renderFilter = () => {
        return (
            <Col lg={6} md={6} xs={12} className={styles.openFilterHolder}>
                <div className={styles.filterActions}>
                    {categoryFilter()}
                    {dateFilter()}
                    {sorting()}
                </div>
                {categoryPopup(rcbArg.filterData)}
                {datePopup()}
                {sortingPopup()}
            </Col>
        );
    };

    if (didSearchTxt && didSearchTxt !== '') {
        //search more button
        const endTxt = () => {
            if (rcbArg.preciseMode === true) {
                return (<>，搜尋<span className={styles.searchMore} onClick={() => { rcbArg.searchMore() }}>更多</span>。</>);
            } else {
                return <>。</>
            }
        };

        //category filter result
        let categoryDisplay = rcbArg.category && rcbArg.category.length !== 0 ? `的 ${rcbArg.category.title} ` : '';

        return (
            <div className={styles.headerSection}>
                <Container>
                    <Row className={styles.summaryCard}>
                        <Col lg={6} md={6} xs={12}>
                            <div className={styles.searchCount}>
                                關於<span className={styles.searchTxt}>「 {didSearchTxt} 」</span>
                                <span className={styles.searchTxt}>{categoryDisplay}</span>
                                共有 {rcbArg.resultCount} 項搜尋結果{endTxt()}
                            </div>
                        </Col>
                        {renderFilter()}
                    </Row>
                    <div className={styles.divider}></div>
                </Container>
            </div>
        );
    }

    return <></>;
};

export default ResultCountBar;